export const flow = {
  formId: "save-flow",
  formField: {
    flowName: {
      name: "flowName",
      label: "flow name",
      type: "text",
      placeholder: "eg. New flow",
      errorMsg: "Flow Name is required.",
    },
    description: {
      name: "description",
      label: "description",
      type: "text",
      placeholder: "eg. This is an information about the flow",
      errorMsg: "Description is required.",
    },
    variables: {
      name: "variables",
      label: "variables",
      type: "tag",
      placeholder: "eg. acCallbackList",
      errorMsg: "",
    },
    integration: {
      name: "integration",
      label: "integration",
      type: "text",
      placeholder: "eg. Chat Bot Flow",
      errorMsg: "Enter a valid integration name",
    },
    logo: {
      name: "logo",
      label: "logo",
      type: "file",
      placeholder: "",
      errorMsg: "Logo is required.",
    },
  },
};
